export const applyStyles = (element) => {
    const style = {};

    if (element['margin-left'] !== undefined) {
        style.marginLeft = typeof element['margin-left'] === 'number'
            ? `${element['margin-left']}px`
            : element['margin-left'];
    }

    if (element['margin-right'] !== undefined) {
        style.marginRight = typeof element['margin-right'] === 'number'
            ? `${element['margin-right']}px`
            : element['margin-right'];
    }

    if (element['margin-top'] !== undefined) {
        style.marginTop = typeof element['margin-top'] === 'number'
            ? `${element['margin-top']}px`
            : element['margin-top'];
    }

    if (element['margin-bottom'] !== undefined) {
        style.marginBottom = typeof element['margin-bottom'] === 'number'
            ? `${element['margin-bottom']}px`
            : element['margin-bottom'];
    }

    if (element['width'] !== undefined) {
        style.width = typeof element['width'] === 'number'
            ? `${element['width']}px`
            : element['width'];
    }

    if (element['height'] !== undefined) {
        style.height = typeof element['height'] === 'number'
            ? `${element['height']}px`
            : element['height'];
    }

    if (element['font-size'] !== undefined) {
        style.fontSize = typeof element['font-size'] === 'number'
            ? `${element['font-size']}px`
            : element['font-size'];
    }

    if (element['font-family'] !== undefined) {
        style.fontFamily = element['font-family'];
    }

    if (element['font-weight'] !== undefined) {
        style.fontWeight = element['font-weight'];
    }

    if (element['text-align'] !== undefined) {
        style.textAlign = element['text-align'];
    }

    if (element['line-height'] !== undefined) {
        style.lineHeight = element['line-height'];
    }

    if (element['color'] !== undefined) {
        style.color = element['color'];
    }

    if (element['background-color'] !== undefined) {
        style.backgroundColor = element['background-color'];
    }

    return style;
};

